import { extensions } from '../../extensions/Extensions';
import { CanvasNineSliceSpritePipe } from './canvas/CanvasNineSliceSpritePipe';
import { NineSliceSpritePipe } from './NineSliceSpritePipe';

extensions.add(CanvasNineSliceSpritePipe);
extensions.add(NineSliceSpritePipe);
